export const tableColumnsManagement = [
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Phone',
    accessor: "phoneNumber"
  },
  {
    Header: 'School',
    accessor: 'school',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Team',
    accessor: 'team',
  },
  {
    Header: 'Role',
    accessor: 'teamRole',
  },
  {
    Header: 'Member Since',
    accessor: 'createdAt',
    sortMethod: (rowA, rowB, columnId) => {
      const dateA = rowA.values[columnId] ? new Date(rowA.values[columnId]).getTime() : 0;
      const dateB = rowB.values[columnId] ? new Date(rowB.values[columnId]).getTime() : 0;
      return dateA - dateB;
    }
  },
  {
    Header: '',
    accessor: 'button',
  },
];
